import { StudentTable } from "./components/StudentTable";
import { useNavigate } from "react-router";
import { useSlideInContext } from "../../context/SlideInContext";
import { StudentDataType } from "./hooks/useSelectedStudent";
import { LAUNCH_OPTIONS, PARENTAL_CONSENT, LAUNCH_FOR_OTHERS } from "../components/SlideIn/contentTypes";
import { useStudentContext } from "../../context/studentContext";
import { useManageModal } from "../Manage/components/ManageModal";
import useExpireStudent from "./hooks/useExpireStudent";
import { useSelectedStudent } from "./hooks";
import usePersonStore from "../store/personStore";
import usePersonAuthStore from "../store/personAuthStore"
import { ParentalConsentType } from "../../__generated__/graphql";

type ViewAllStudentsProps = {
    onBack: () => void,
}

export const ViewAllStudents = ({ onBack }: ViewAllStudentsProps) => {
    const navigate = useNavigate();
    const { changeStudent } = useStudentContext();
    const { handleContent } = useSlideInContext();
    const { openModal, closeModal } = useManageModal();
    const personState = usePersonStore(state => state)
    const roles = usePersonAuthStore((state) => state.roles)
    const { expireStudent } = useExpireStudent();
    const { setSelectedStudent } = useSelectedStudent()
    const handleSelectedStudent = (student: StudentDataType) => {
        changeStudent(student);
        navigate(`/dashboard/student/${student?.id}/sessions`)
    }
    const handleStudentDetails = (student: StudentDataType) => {
        setSelectedStudent(student);
        changeStudent(student)
        navigate(`/manage/children/details/${student?.id}`)
    }
    const handleLaunch = (student: any) => {
        if (student?.expired) {
            openModal({
                type: 'STUDENT_IS_EXPIRED',
                cancelButtonLabel: "Close"
            })
        } else {
            changeStudent(student);
            const studentConsentStatus = student.parentalConsentStatus?.toUpperCase() ?? null;
            if (personState.company.consentPolicy && (studentConsentStatus !== ParentalConsentType.Given && studentConsentStatus !== ParentalConsentType.Timelapsed)) {
                if (!studentConsentStatus) {
                    handleContent(PARENTAL_CONSENT)
                } else if (studentConsentStatus === ParentalConsentType.Pending) {
                    handleContent(PARENTAL_CONSENT)
                } else {
                    openModal({ type: "PARENTAL_CONSENT_NOT_GIVEN", cancelButtonLabel: "close" })
                }
            }
            else if (roles.includes("OFFICE ADMIN") || roles.includes("SUPER ADMIN")) {
                handleContent(LAUNCH_FOR_OTHERS)
                // TODO: ADD A NEW FUNCTION TO ALLOW THEM TO LAUNCH ON BEHALF OF OTHERS
            } else {
                handleContent(LAUNCH_OPTIONS);
            }
        }
    }

    const handleExpire = async (student: any) => {
        openModal({
            type: 'EXPIRE_STUDENT',
            confirmButtonType: 'WARNING',
            confirmButtonLabel: 'Expire',
            onConfirm: async () => {
                openModal(state => ({
                    ...state,
                    status: 'SAVING'
                }))

                await expireStudent(student.id)

                closeModal();
            }
        })
    }
    return (
        <StudentTable
            title="All Children"
            onBack={onBack}
            showNew={!roles.includes("SUPPORT ADMIN")}
            onSelectedStudent={(student, action) => {
                switch (action) {
                    case "LAUNCH":
                        handleLaunch(student)
                        break;
                    case "REPORTS":
                        handleSelectedStudent(student)
                        break;
                    case "DETAILS":
                        handleStudentDetails(student)
                        break;
                    case "EXPIRE":
                        handleExpire(student)
                        break;
                    default:
                        throw Error(`Although the student ${student.id} is selected, action ${action} is not implemented`);
                }
            }}
        />
    )
}